
<div class="logo-container">
  <!-- Replace with your actual logo -->
  <img src="/assets/img/logo-image.svg" alt="Logo" class="logo" />
  <div class="text">¡Compra exitosa!
    <p class="pt-2 font-weight-normal">
      ¡Ya casi estamos listos para que puedas viajar con tranquilidad gracias a Blue Assist! Para hacer efectiva su cobertura debe de activar su certificado:
    </p>
   
    <div class="button-box mb-3">
      <button class="continue-btn-steps" (click)="nextStep()" [disabled]="isloading || !hasCertificateNumber">
        {{isloading ? 'Activando...' : (!hasCertificateNumber ? 'Certificado No Disponible' : 'Activar Certificado')}}
      </button>
    </div>
    
    <p class="font-weight-normal">
      <span class="font-bold">¿Prefieres activar más tarde?</span>
      Encuentra el enlace en tu correo de confirmación.
    </p>
  </div>
</div>

<!-- Loading Modal -->
<div class="modal fade" id="quoteLoadingModal" tabindex="-1" aria-labelledby="quoteLoadingModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered send-quote-modal">
    <div class="modal-content">
      <div class="modal-body">
          <div>
            <h5 class="modal-title" id="exampleModalLabel">Estamos activando tu certificado…</h5>
            <p class="no-bg">Esto puede tardar unos segundos. ¡Gracias por tu paciencia!</p>
            <img src="/assets/img/loading_logo.gif" alt="Blue Assist" class="loading-logo">
          </div>
      </div>
    </div>
  </div>
</div>

<!-- Hidden toggle button for loading modal -->
<button type="button" id="quoteLoadingModalToggle" class="btn btn-primary quoteLoadingModal" data-bs-toggle="modal"
         data-bs-target="#quoteLoadingModal" style="display: none;">Activar Certificado</button>

<!-- <div class="quote-step9-quote-step4-5 animation-fadein" [ngClass]="rootClassName">
  <img
    [attr.alt]="rectangle1269alt"
    [attr.src]="rectangle1269src"
    class="quote-step9-rectangle1269"
  />
  <span class="quote-step9-text"><span>volver</span></span>
  <div class="quote-step9-container">
    <span class="quote-step9-text02 Titular,Bold,18">
      <span>¡Compra exitosa!</span>
    </span>
    <span class="quote-step9-text04 DesK,P4,Regular,16">
      <span>
        ¡Ya casi estamos listos para que puedas viajar con tranquilidad gracias
        a Blue Assist! Ahora solo debes de activar tu asistencia de viaje
        haciendo clic en el botón.
      </span>
    </span>
    <button class="quote-step9-cotizar" (click)="nextStep()">
      <span class="quote-step9-text06 Mob,H2,Bold12">
        <span>Activar Certificado</span>
      </span>
    </button>
    
    <img
      [attr.alt]="gradient21alt"
      [attr.src]="gradient21src"
      class="quote-step9-gradient21"
    />
  </div>
</div> -->
